import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { ScreenSaverService } from './screen-saver.service';

@Injectable({
    providedIn: 'root'
})
export class ScreenSaverGuard implements CanActivate, CanActivateChild {
    constructor(
        private screenSaver: ScreenSaverService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.evaluate(state.url);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.evaluate(state.url);
    }

    private evaluate(url: string): boolean {
        if (!this.screenSaver.isLocked() || !this.screenSaver.hasPin()) {
            return true;
        }

        return false;
    }
}
